export default __webpack_public_path__ + "static/media/snowtrace.b7c6484f.svg";